import get from 'lodash/get'

export const TABLE_COLUMNS = [
  {
    name: 'product.name',
    icon: 'el-icon-document',
    width: 100,
  },
  {
    name: 'version',
    label: 'Default Version',
    icon: 'el-icon-document',
    width: 100,
    component: {
      props: {
        value(_, row) {
          if (row.latest) return 'Latest version'
          else return get(row, 'version.name', '-')
        },
      },
    },
  },
]

export const ROLE_COLUMN = {
  name: 'roles',
  label: 'Roles',
  icon: 'el-icon-document',
  component: {
    props: {
      value(_, row) {
        return (row.roles || []).map(r => r.friendlyName).join(', ')
      },
    },
  },
}

export const PROVIDER_ID_COLUMN = {
  name: 'externalProvider.externalId',
  label: 'Unique Provider ID',
  icon: 'el-icon-document',
}
